import ReactDOM from 'react-dom';
import React from 'react';
import Promise from 'bluebird';
import ReactHighcharts from 'react-highcharts';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faCircleNotch,
  faClock,
  faPlug,
  faSortDown,
  faBars,
  faExclamationTriangle,
  faUserCircle,
  faKey,
  faSignOutAlt,
  faListOl,
  faArrowUp,
  faArrowDown,
} from '@fortawesome/free-solid-svg-icons';
import 'normalize.css/normalize.css';
import App from './components/App/App';
import './styles/index.css';


// Bluebird promise
global.Promise = Promise;
window.Promise = Promise;

// Font-awesome
library.add(
  faCircleNotch,
  faClock,
  faPlug,
  faSortDown,
  faBars,
  faExclamationTriangle,
  faUserCircle,
  faKey,
  faSignOutAlt,
  faListOl,
  faArrowUp,
  faArrowDown,
);

// React Highcharts
ReactHighcharts.Highcharts.setOptions({
  global: {
    useUTC: false,
  },
});


ReactDOM.render(
  <App />,
  document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js